// Module Import
//---------------------------------
import React from 'react'
import styled from 'styled-components'
import Accordion from '../AccordionRental/AccordionRental'

// Component Import
//---------------------------------

const AccessoriesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

// Styled Component Declarations
//---------------------------------

// Component Export
//---------------------------------
export default function RentalProductAccessories({ onAction, accessories, loadingBooking }) {
  const sensorAccessories =
    accessories.filter(
      (accessory) => accessory && accessory?.tags?.some((tag) => tag.toLowerCase() === 'sensors')
    ) || []
  const lensAccessories =
    accessories.filter(
      (accessory) => accessory && accessory?.tags?.some((tag) => tag.toLowerCase() === 'lenses')
    ) || []
  const optionalExtraAccessories =
    accessories.filter(
      (accessory) =>
        accessory &&
        !accessory?.tags?.some((tag) => tag.toLowerCase() === 'sensors') &&
        !accessory?.tags?.some((tag) => tag.toLowerCase() === 'lenses')
    ) || []

  return (
    <AccessoriesWrapper>
      {sensorAccessories.length !== 0 && (
        <Accordion
          header="Choose a Sensor"
          products={sensorAccessories}
          isLoading={loadingBooking}
          onAction={onAction}
        />
      )}

      {lensAccessories.length !== 0 && (
        <Accordion
          header="Choose Lenses"
          products={lensAccessories}
          isLoading={loadingBooking}
          onAction={onAction}
        />
      )}

      {optionalExtraAccessories.length !== 0 && (
        <Accordion
          header="Optional Extra Accessories"
          products={optionalExtraAccessories}
          isLoading={loadingBooking}
          onAction={onAction}
        />
      )}
    </AccessoriesWrapper>
  )
}

RentalProductAccessories.propTypes = {}
